import { Link, useNavigate } from 'react-router-dom';

export function Logo() {
  const navigate = useNavigate();
  return (
    <a
      href="/dashboard"
      onClick={(e) => {
        e.preventDefault();
        navigate('/dashboard');
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
        <path d="M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32 32-14.3 32-32S49.7 0 32 0ZM3.5 19.9c1.6-3.7 3.8-7 6.6-9.8 2.8-2.8 6.2-5.1 9.8-6.6 3.8-1.6 7.9-2.4 12.1-2.4s8.2.8 12.1 2.4c3.7 1.6 7 3.8 9.8 6.6 2.8 2.8 5.1 6.2 6.6 9.8 1.6 3.7 2.4 7.6 2.4 11.6H1c0-4 .9-7.9 2.4-11.6Zm57 24.2c-1.6 3.7-3.8 7-6.6 9.8-2.8 2.8-6.2 5.1-9.8 6.6-3.8 1.6-7.9 2.4-12.1 2.4s-8.2-.8-12.1-2.4c-3.7-1.6-7-3.8-9.8-6.6-2.8-2.8-5.1-6.2-6.6-9.8-1.6-3.7-2.4-7.6-2.4-11.6H63c0 4-.9 7.9-2.4 11.6Z" fill="#fff"/>
        <path d="M20.2 25.8V25l6.7-6.8c1.6-1.7 2.4-3.2 2.4-4.5s-.4-1.9-1.1-2.6c-.7-.7-1.6-1-2.7-1s-2.3.4-3.1 1.1c-.8.7-1.2 1.7-1.2 2.9h-1c0-1.5.5-2.7 1.5-3.6 1-.9 2.3-1.4 3.8-1.4s2.6.4 3.5 1.3c.9.9 1.4 1.9 1.4 3.3s-.2 1.6-.7 2.5c-.5.9-1.2 1.7-2 2.6l-6 6h9v1H20.2Zm23.6-4.5v1h-2.4v3.5h-1.1v-3.5h-8.7v-.8l8.5-12h1.3v11.9h2.4Zm-11.1 0h7.6V10.7l-7.6 10.6Zm-6 16.9h10.6v.8l-7.5 15.8h-1.2l7.5-15.6h-9.4v-1Z" fill="#fff"/>
      </svg>
    </a>
  );
}
